import { apiClient } from "@/services/apiClient";
import type { NotificationEventDto } from "../types/dashboard";

export async function getMyNotifications(): Promise<NotificationEventDto[]> {
  const res = await apiClient.get<NotificationEventDto[]>("/api/notifications/my");
  return res.data;
}

export async function getNotificationByGuid(eventGuid: string): Promise<NotificationEventDto> {
  const res = await apiClient.get<NotificationEventDto>(`/api/notifications/event/${eventGuid}`);
  return res.data;
}